import ReactGA4 from "react-ga4";

// Login event.
const appLogin = (): void => ReactGA4.event("login", { method: "okhati app" });

const gaEvents = { appLogin };

export default gaEvents;
